module.exports = __webpack_public_path__ + "img/location.45d51da9.svg";